/**
 * Returns directive that creates custom event that triggers when attribute value changes in DOM
 * @param {String} attrName
 * @param {String} eventName
 */
export function AttributeChangeDirective(attrName, eventName) {
    let observer;
    let customEvent;

    return {
        bind: inputElem => {
            customEvent = new CustomEvent(eventName);
            observer = new MutationObserver(mutationList => inputElem.dispatchEvent(customEvent));
            observer.observe(inputElem, {
                attributeFilter: [attrName],
            });
        },
        unbind: inputElem => {
            inputElem.removeEventListener(customEvent);
            observer.disconnect();
        },
    };
}
